/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  APPLICATION_FRAGMENT = 'application-fragment',
  APPLICATION_ROUTE = 'application-route',
  AVATAR_ROOT = 'avatar-root',
  COOKIES_POLICY_FRAGMENT = 'cookies-policy-fragment',
  COOKIES_POLICY_ROUTE = 'cookies-policy-route',
  FRAGMENT_ROOT_EC = 'fragment-root-ec',
  FRAGMENT_ROOT_EMAR = 'fragment-root-emar',
  LOGIN_FOUNDATION_FRAGMENT = 'login-foundation-fragment',
  LOGIN_FOUNDATION_ROUTE = 'login-foundation-route',
  LOGOUT_INACTIVITY_FRAGMENT = 'logout-inactivity-fragment',
  LOGOUT_INACTIVITY_ROUTE = 'logout-inactivity-route',
  MAIN_LAYOUT = 'main-layout',
  PANEL_RESOLUTION = 'panel-resolution',
  PRIVACY_NOTICE_FRAGMENT = 'privacy-notice-fragment',
  PRIVACY_NOTICE_ROUTE = 'privacy-notice-route',
  ROOT_PANEL = 'root-panel',
  ROUTE_ROOT_EC = 'route-root-ec',
  ROUTE_ROOT_EMAR = 'route-root-emar',
  SEARCH_PATIENT_EC = 'search-patient-ec',
  SEARCH_PATIENT_EC_FRAGMENT = 'search-patient-ec-fragment',
  SPOTLIGHT_FRAGMENT = 'spotlight-fragment',
  SPOTLIGHT_ROUTE = 'spotlight-route',
  TERMS_OF_USE_FRAGMENT = 'terms-of-use-fragment',
  TERMS_OF_USE_ROUTE = 'terms-of-use-route',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
  USER_DETAILS_FRAGMENT = 'user-details-fragment',
  USER_DETAILS_ROUTE = 'user-details-route',
}
export { RootAliases };
